/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {get} from '../../api/api';
import {
  uriGetCategoryList,
  uriGetPreAuthDocuments,
  uriGetPreAutorizationDetail,
  uriGetProcedures,
  uriPreAutorizations,
  uriStatuses,
} from '../../api/endpoints';
import AppButton from '../../components/app-button';
import AppWrapper from '../../components/app-wrapper';
import {Expense} from '../../components/expenses-detail/ExpensesDetail';
import Header1 from '../../components/headers/header1';
import Icon from '../../components/icon';
import {Column, Row} from '../../components/layout';
import {addToGlobalStyles, setWizard} from '../../store/actions';
import colors from '../../util/colors';
import {Icons} from '../../util/icons';
import {strings} from '../../util/strings';
import {sortArrayByParam} from '../../util/utility';
import ClaimItemsFilter, {
  ClaimItemsFilterProps,
} from '../reimbursements/components/ClaimItemsFilter';
import ClaimsFilterModal from '../reimbursements/components/ClaimsFilterModal';
import {useHistory} from 'react-router-dom';
import * as fonts from '../../util/fonts';

import './styles.scss';
import PreAuthorizationList from './components/PreAuthorizationList';
import PreAuthorizationDetail from './components/PreAuthorizationDetail';
import PopupList from './../../components/popup-list/index';
import RequestPopupPreAuthorization from './components/request-popup-pre-authorization';
import PreAuthorizationPreRequest from './components/pre-authorization-pre-request';
import {globalStylesReducer} from '../../store/reducers/mix';
import AppParagraph from '../../components/app-paragraph';
import {LoadingOutlined} from '@ant-design/icons';
import PreAuthorizationtListItem from './components/PreAuthorizationtListItem';

// API response
export type PreAuthorizationItem = {
  svcGrp: string;
  dos: string;
  decisionState: string;
  decisionStateId: string;
  decisionDate: string;
  providerName: string;
  clinicName: string;
  serviceNumber: string;
  convention: string;
  eventId: string;
};
export type IPreAuthorizationProcedure = {
  alias: string;
  buAlias: string;
  id: number;
  status: string;
  title: string;
  buPreAuthProcedureDetails: IProcedureDetail[];
};
export type IProcedureDetail = {
  frontendTitle: string;
  id: number;
  fileDescription: string;
  serviceGroup: string;
  languageAlias: string;
  preAuthProcedureAlias: string;
  file: string;
};
type PreAuthorizationApiResponse = {
  data: PreAuthorizationData;
};
type PreAuthorizationData = {
  items: PreAuthorizationItem[];
  total: number;
  statusCode: string;
};
type PreAuthDocument = {
  url: string;
  description: string;
};
type PreAuthorizationDetailApiResponse = {
  eventId: string;
  dosFrom: string;
  dosThru: string;
  entrydate: string;
  statusCode: string;
};
// Props
type PreAuthorizationProps = {
  user: any;
  addToGlobalStyles(value: any): void;
  selectedBu: any;
  language: any;
  labels: typeof strings.pt.preAuthorizations;
  labelsRefund: typeof strings.pt.refund;
  buStyles: any;
  setWizard(values: any): void;
};
function PreAuthorizations(p: PreAuthorizationProps) {
  const [filterShouldRefresh, setFilterShouldRefresh] = useState(false);
  const [selectedItem, setSelectedItem] = useState<PreAuthorizationItem>();
  const [expenses, setExpenses] = useState<Expense[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalPreRequest, setShowModalPreRequest] = useState(false);
  const [showModalRequestDocuments, setShowModalRequestDocuments] =
    useState(false);
  const [preAuthDocs, setPreAuthDocs] = useState<PreAuthDocument[]>([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [itemsSource, setItems] = useState<PreAuthorizationItem[]>();
  const [categories, setCategories] = useState<any[]>([]);
  const [statuses, setStatuses] = useState<any[]>([]);
  const history = useHistory();
  const [serviceNumbers, setServiceNumbers] = useState<any[]>([]);
  const [preAuthDetail, setPreAuthDetail] = useState();
  const [flagServiceNbrPatientName, setFlagServiceNbrPatientName] =
    useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [flagListUpdated, setFlagListUpdated] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const featureName = 'PreAuthorizationsList';

  const filterParameterChanged = (
    filterParameter: string,
    ParameterValue: string | Date
  ) => {
    var newFilter = {...filter};
    (newFilter as any)[filterParameter] = ParameterValue;
    setFilter(newFilter);
    setFilterShouldRefresh(true);
  };

  let filterProps: ClaimItemsFilterProps = {
    controlLabels: {
      filterParmOne: p.labels?.refund_preAuthorization_filter_processTypeLabel,
      filterDateFrom:
        p.labels?.refund_preAuthorization_filter_processStatusLabel,
    },
    filterOneOptions: [],
    filterTwoOptions: [],
    filterParmOne: '',
    filterParmTwo: '',
    periodFrom: moment().subtract(3, 'month').toDate(),
    periodTill: moment().add(3, 'month').toDate(),
    filterParameterChanged: filterParameterChanged,
    filtersHaveChanged: filterShouldRefresh,
  };
  const [filter, setFilter] = useState<ClaimItemsFilterProps>(filterProps);

  /*
    Event handlers / callback functions
    */
  const changedSelectedItem = async (selectedItem: PreAuthorizationItem) => {
    setSelectedItem(selectedItem);
    setShowModal(true);
    getAuthorizationDetail(selectedItem);
  };

  const modalWasClosed = () => {
    setFilterShouldRefresh(filter.filtersHaveChanged);
  };

  /* API calls */
  const getListOfPreAutorizations = async () => {
    const filterFromDate =
      filter.periodFrom === undefined
        ? '1900-01-01'
        : moment(filter.periodFrom).format('YYYY-MM-DD');
    const filterToDate =
      filter.periodTill === undefined
        ? '2030-12-31'
        : moment(filter.periodTill).format('YYYY-MM-DD');
    try {
      let res = await get(
        uriPreAutorizations(
          p.selectedBu.memId,
          p.selectedBu.buId,
          0,
          9999,
          filterFromDate,
          filterToDate,
          filter.filterParmOne,
          filter.filterParmTwo
        ),
        false,
        0,
        featureName
      );
      return res;
    } catch (e: any) {}
  };

  const getAuthorizationDetail = async (selectedItem: PreAuthorizationItem) => {
    try {
      setLoadingDetail(true);
      await get(
        uriGetPreAutorizationDetail(
          p.selectedBu.buId,
          selectedItem.serviceNumber
        )
      ).then(async (preAuthorizationDetailsResp: any) => {
        setPreAuthDetail(preAuthorizationDetailsResp.data);
        await get(
          uriGetPreAuthDocuments(
            p.selectedBu.buId,
            selectedItem.serviceNumber,
            preAuthorizationDetailsResp.data.eventId
          )
        ).then((res: any) => {
          setPreAuthDocs(formatDocuments(res.notificationDetails));
        });
      });
    } catch {
      setPreAuthDocs([]);
    } finally {
      setLoadingDetail(false);
    }
  };

  const formatDocuments = (documents: any[]) => {
    let result: any = [];
    documents.forEach((doc) => {
      if (doc.status === 'SENT' && doc.sentTo?.toUpperCase().includes('MEMB')) {
        result.push({description: doc.filename, url: doc.url});
      }
    });
    return result;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getTheAutorizations = async () => {
    setIsLoading(true);
    if (p.selectedBu) {
      await getListOfPreAutorizations().then((res: any) => {
        var arr: any[] = [];
        res?.data?.items?.map((r: {serviceNumber: any}) => {
          arr = arr.concat(r.serviceNumber);
        });
        setServiceNumbers(arr);
        try {
          setItems(
            (res as PreAuthorizationApiResponse)?.data
              ?.items as PreAuthorizationItem[]
          );
          setFlagListUpdated(true);
          setIsLoading(false);
        } catch (e: any) {
          setItems([]);
        }
      });
    }
  };

  useEffect(() => {
    setFilterShouldRefresh(true);
    setFlagServiceNbrPatientName(false);
  }, [p.selectedBu.memId]);

  //Get the filter options for the filter parms
  useEffect(() => {
    async function getListOfProcedures() {
      if (p.selectedBu) {
        try {
          let response: any = await get(
            uriGetProcedures(p.selectedBu.buId),
            false,
            0,
            featureName
          );
          return response?.data?.items.filter(
            (item: IPreAuthorizationProcedure) => item.status === 'ACTIVE'
          );
        } catch {}
      }
    }
    async function getListOfStatuses() {
      return await get(
        uriStatuses('PRE_AUTHOTIZATIONS'),
        false,
        0,
        featureName
      );
    }

    let newFilter = {...filter};

    getListOfProcedures().then((res: IPreAuthorizationProcedure[]) => {
      const proceduresNames: any = [];
      res.forEach((elem: IPreAuthorizationProcedure) => {
        const procAux: IProcedureDetail | undefined =
          elem.buPreAuthProcedureDetails.find(
            (procedure: IProcedureDetail) =>
              procedure.languageAlias === p.language
          );
        procAux && proceduresNames.push(procAux);
      });

      let cat: any[] = [];

      proceduresNames.forEach((elem: IProcedureDetail) => {
        elem.preAuthProcedureAlias &&
          elem.frontendTitle &&
          cat.push({
            value: elem.serviceGroup,
            label: elem.frontendTitle,
          });
      });

      sortArrayByParam(cat, 'label');
      setCategories(cat);
      newFilter.filterOneOptions = cat;
      setFilter(newFilter);
    });

    getListOfStatuses().then(async (res: any) => {
      const statusOptions = (res.data?.items as any[])
        .filter((elem) => elem.stateName !== 'Default')
        .map((elem) => {
          return {
            value: elem.coreStatusName || elem.stateName,
            label: elem.stateName,
            colorCode: elem.color,
            stateId: elem.stateId,
          };
        });

      sortArrayByParam(statusOptions, 'label');
      setStatuses(statusOptions);
      newFilter.filterTwoOptions = statusOptions;
      setFilter(newFilter);
    });

    setFilterShouldRefresh(true);
  }, []);

  // refresh filter when flag is set
  useEffect(() => {
    if (filterShouldRefresh) {
      setFlagListUpdated(false);
      getTheAutorizations();
      setFilterShouldRefresh(false);
    }

    setFlagServiceNbrPatientName(false);
  }, [filterShouldRefresh]);

  let statusId = selectedItem?.convention?.toLowerCase();
  let color = statuses.find((e) => e.value === statusId)?.colorCode;

  // render component
  return (
    <>
      <Column className="reimbursement-history-container ">
        <Row className="reimbursement-history-titlerow reimbursement-history-row">
          <Column className="reimbursement-history-titlecolumn pre-authorization-title">
            <Header1
              style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
              className="pre-authorization-title">
              {p.labels?.refund_preAuthorization}
            </Header1>
            <label style={{...fonts.M}} className="pre-authorization-subtitle">
              {p.labels?.refund_preAuthorization_subTitle}
            </label>
          </Column>
          <Column className="reimbursement-history-requestcolumn">
            <AppButton
              onClick={() => {
                p.setWizard({});
                setShowModalRequestDocuments(true);
              }}
              className="preauthorizations-request-preauthorization-button mt-3">
              {p.labels?.refund_preAuthorization_addPreAuthorization}
            </AppButton>
            <Row className="justify-content-center mt-4 pre-authorization-label-when-add-preauthorization">
              <a
                className="pre-authorization-label-anchor"
                style={{
                  ...fonts.M,
                  ...fonts.Bold,
                  color: p.buStyles?.primaryColor || colors.blue,
                }}
                onClick={() => setShowModalPreRequest(true)}>
                <AppParagraph
                  label={
                    p.labels?.refund_preAuthorization_whenAddPreAuthorization
                  }
                />
              </a>
              <Icon
                name={Icons.CHEVRON_RIGHT}
                width="20"
                height="20"
                changeViewbox={false}
                style={{fontWeight: 'bold'}}
                color={p.buStyles?.primaryColor || colors.blue}
              />
            </Row>
          </Column>
        </Row>
        <Row className="reimbursement-history-row reimbursement-history-row-filter">
          <ClaimItemsFilter
            restrictDateInterval={true}
            allowFutureDates={true}
            filterParmOne={filter.filterParmOne}
            filterParmTwo={filter.filterParmTwo}
            periodFrom={filter.periodFrom}
            periodTill={filter.periodTill}
            filterParameterChanged={filterParameterChanged}
            filterOneOptions={filter.filterOneOptions}
            filterTwoOptions={filter.filterTwoOptions}
            controlLabels={{
              filterParmOne:
                p.labels?.refund_preAuthorization_filter_processTypeLabel,
              filterParmTwo:
                p.labels?.refund_preAuthorization_filter_processStatusLabel,
              filterDateFrom: p.labels?.filterDateLabel,
            }}
            filtersHaveChanged={filter.filtersHaveChanged}></ClaimItemsFilter>
        </Row>
        {isLoading ? (
          <LoadingOutlined style={{fontSize: 24, marginTop: '50px'}} spin />
        ) : (
          <Row className="reimbursement-history-row reimbursement-history-declarationslist-row">
            <Column className="reimbursement-history-declarationslist-column">
              <Row>
                <Column className="reimbursement-history-filterbuttoncolumn">
                  <AppButton
                    className="reimbursement-history-filterbutton"
                    onClick={() => setShowFilterModal(true)}>
                    <Row className="reimbursement-history-filter-row">
                      <Icon
                        className="reimbursement-history-filter-icon"
                        name={Icons.FILTER}
                        color={colors.white}
                        width="16"
                        height="16"
                        changeViewbox={false}
                        viewBox={'0 -5 26 30'}
                      />
                      {p.labels?.refund_preAuthorization_filter_button}
                    </Row>
                  </AppButton>
                </Column>
              </Row>

              <PreAuthorizationList
                authorizationItems={
                  itemsSource && itemsSource.length > 0 ? itemsSource : []
                }
                clickable={flagListUpdated}
                selectedItem={changedSelectedItem}
                labels={p.labels}
                statuses={statuses}
              />
            </Column>
          </Row>
        )}
      </Column>
      <ClaimsFilterModal
        setShowFilterModal={setShowFilterModal}
        showFilterModal={showFilterModal}
        filterProps={filter}
        setFilter={setFilter}
        modalWasClosed={modalWasClosed}
      />
      <PreAuthorizationDetail
        selectedItem={selectedItem}
        preAuthDetail={preAuthDetail}
        expenses={expenses}
        color={color}
        showModal={showModal}
        setShowModal={setShowModal}
        labels={p.labels}
        user={p.user}
        documents={preAuthDocs}
        statuses={statuses}
        loading={loadingDetail}
      />
      <PreAuthorizationPreRequest
        show={showModalPreRequest}
        setShowModal={setShowModalPreRequest}
      />
      <RequestPopupPreAuthorization
        show={showModalRequestDocuments}
        setShowModal={
          setShowModalRequestDocuments
        }></RequestPopupPreAuthorization>
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  language,
  strings,
  user,
  globalStyles,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  language: language.value,
  labels: strings.value.pt.preAuthorizations,
  buStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(PreAuthorizations)
);
